<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="headline primary white--text">
                    {{'Anomaly Descriptions'|translate}}
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <span style="width:300px;"><v-text-field  class="mr-4" clearable v-model="search" type="text" :label="'Keyword filter'|translate"></v-text-field></span>
                    <v-btn class="accent" @click="editedItem=null;dialog=true" :disabled="!$can('update', 'AnomalyDescription')"><v-icon small class="mr-2">fa-plus</v-icon> {{'Add Record'|translate}}</v-btn>
                    <anomaly-description-dialog v-model="dialog" :item="editedItem" v-on:doreload="refresh()"></anomaly-description-dialog>
                </v-card-actions>

                <v-card-text>
 <v-data-table
                    :headers="headers"
                    :items="anomalyDescription"
                    class="elevation-1"
                    :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                    :items-per-page="25"
                    :search="search2"
            >
      <template v-slot:items="props">
        <td>{{ props.item.desc }}</td>
        <td>{{ props.item.severity }}</td>
        <td>{{ props.item.topic }}</td>
        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            v-if="$can('update', 'AnomalyDescription')"
            @click="$can('update', 'AnomalyDescription') && editItem(props.item)"
          >
            fa-edit
          </v-icon>
          <v-icon
            small
            v-if="$can('update', 'AnomalyDescription')"
            @click="$can('update', 'AnomalyDescription') && deleteItem(props.item)"
          >
            fa-trash
          </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">{{'Reset'|translate}}</v-btn>
      </template>
    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {getAnomalyDescription, deleteAnomalyDescription} from '../helper'
import AnomalyDescriptionDialog from "../components/AnomalyDescriptionDialog";

export default {
    name: 'AnomalyDescription',
  components: { AnomalyDescriptionDialog },
  data(){
        return{  
      dialog: false,
      headers: [
        { text: this.$options.filters.translate('Description'), value: 'desc' },
        { text: this.$options.filters.translate('Severity'), value: 'severity', sortable: false },
        { text: this.$options.filters.translate('Topic'), value: 'topic'},
        { text: this.$options.filters.translate('Actions'), sortable: false },
      ],
      anomalyDescription: [],
      editedIndex: -1,
      editedItem: {
      },
      search: '',
      search2: ''
    }},

  mounted() {
    this.initialize()
  },
  watch: {
    search(){
      this.debounce(this.syncSearches,500);
    }
  },
    methods: {
      initialize () {
        this.refresh()
      },

      editItem (item) {
        this.editedIndex = this.anomalyDescription.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      async deleteItem (item) {
        const index = this.anomalyDescription.indexOf(item)
        if (confirm(this.$options.filters.translate('Are you sure you want to delete this item?')) ){
          this.anomalyDescription.splice(index, 1)
          await deleteAnomalyDescription({
            'anomaly_description_id': item.anomaly_description_id
          })
          this.refresh()
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.anomalyDescription[this.editedIndex], this.editedItem)
        } else {
          this.anomalyDescription.push(this.editedItem)
        }
        this.close()
      },
      async refresh() {
        let df = await getAnomalyDescription({
          facility_name: this.$store.state.pointsListStore.pointsList.facility_name
        })
        this.anomalyDescription = df['result']
      },
      syncSearches(){
        this.search2=this.search
      },
      debounce(callback, wait) {
        clearTimeout(this.timeout);
        this.timeout= setTimeout(() => callback(), wait);
      },
    }
  }
</script>

<style scoped>

</style>
